exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-96994346]{position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,.6);z-index:999;display:flex;justify-content:center;align-items:center}.wrapper[data-v-96994346]{position:relative}.__darkmode__ .modal[data-v-96994346]{background:rgba(0,0,0,.75)}", ""]);

// exports
